<div class="mb-3 d-flex flex-row-reverse">
  <app-account-filter [filter]="accountFilter" class="col-2 py-2"
    (filterChanged)="onAccountFilterChange($event)"></app-account-filter>
</div>
<div class="row gx-3">
  <div class="col-lg-3 col-md-6">
    <app-trips-widget></app-trips-widget>
  </div>
  <div class="col-lg-3 col-md-6">
    <app-overtime-widget></app-overtime-widget>
  </div>
  <div class="col-lg-3 col-md-6">
    <app-kilometers-driven-widget></app-kilometers-driven-widget>
  </div>
  <div class="col-lg-3 col-md-6">
    <app-driver-performance-widget></app-driver-performance-widget>
  </div>
</div>
<div class="row gx-3 operations-dashboard__cards pt-4" *transloco="let t; prefix: 'driverOverview.cards'">
  <!-- card-item -->
  <div class="col-lg-6 col-md-4 col-sm-6 pb-4">
    <div class="card card-featured card-large clickable" [routerLink]="['/driver-management/driver-information']">
      <img src="assets\images\driver-management\card1.jpg" alt="" />
      <div class="card-body position-absolute d-flex flex-column justify-content-between text-white h-100 w-100">
        <div class="d-flex align-items-start justify-content-between w-100">
          <div class="card-icon">
            <i class="ph-duotone ph-users-three ph-2x"></i>
          </div>
        </div>
        <div>
          <h3 class="card-title">{{ t('driverManagement.title') }}</h3>
          <p class="card-text text-white">
            {{ t('driverManagement.description') }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <!-- card-item -->
  <div class="col-lg-6 col-md-4 col-sm-6 pb-4">
    <div class="card card-featured clickable" [routerLink]="['/driver-management/driver-manager']">
      <img src="assets\images\driver-management\card2.jpg" alt="" />
      <div class="card-body position-absolute d-flex flex-column justify-content-between text-white h-100 w-100">
        <div class="d-flex align-items-start justify-content-between w-100">
          <div class="card-icon">
            <i class="ph-duotone ph-steering-wheel ph-2x"></i>
          </div>
        </div>
        <div>
          <h3 class="card-title">{{ t('driverManager.title') }}</h3>
          <p class="card-text text-white">
            {{ t('driverManager.description') }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <!-- card-item -->
  <div class="col-lg-6 col-md-4 col-sm-6 pb-4">
    <div class="card card-featured clickable" [routerLink]="['/driver-management/overtime-management']">
      <img src="assets\images\driver-management\card3.jpg" alt="" />
      <div class="card-body position-absolute d-flex flex-column justify-content-between text-white h-100 w-100">
        <div class="d-flex align-items-start justify-content-between w-100">
          <div class="card-icon">
            <i class="ph-duotone ph-money ph-2x"></i>
          </div>
        </div>
        <div>
          <h3 class="card-title">{{ t('driverFinances.title') }}</h3>
          <p class="card-text text-white">
            {{ t('driverFinances.description') }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <!-- card-item -->
  <div class="col-lg-6 col-md-4 col-sm-6 pb-4">
    <div class="card card-featured clickable" [routerLink]="['/driver-management/dashboard']">
      <img src="assets\images\driver-management\card4.jpg" alt="" />
      <div class="card-body position-absolute d-flex flex-column justify-content-between text-white h-100 w-100">
        <div class="d-flex align-items-start justify-content-between w-100">
          <div class="card-icon">
            <i class="ph-duotone ph-chart-bar ph-2x"></i>
          </div>
        </div>
        <div>
          <h3 class="card-title">{{ t('driverOperations.title') }}</h3>
          <p class="card-text text-white">
            {{ t('driverOperations.description') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>